import React, { Component } from "react";
import { TextAreaInput } from "ui-components";

import { CommentWrapper } from "./styled";

class Comment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value
    };
  }

  /**
   * New properties likely indicates a new comment to load
   * @param  {object} nextProps New properties
   */
  componentWillReceiveProps(nextProps) {
    // Handle receiving new props and reinitializing comment value
    if (nextProps.value !== this.state.value) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  /**
   * Handle the user changing the comment (update local state for performance reasons)
   * @param  {object} event Event object
   */
  onChange = event => {
    // Update the comment value
    this.setState({
      value: event.target.value
    });
  };

  render() {
    return (
      <CommentWrapper>
        <TextAreaInput
          placeholder="Add a comment&hellip;"
          onChange={this.onChange}
          onBlur={this.props.onBlur}
          value={this.state.value}
        />
      </CommentWrapper>
    );
  }
}

export default Comment;



// WEBPACK FOOTER //
// ./src/common/components/Comment/Comment.jsx